var touchMoveEvent = new Event("touchmove");

function enableSlider() {
	window.mainSlider?.enable();
}

function enableNotScrollSlider() {
	window.mainSlider?.disable();
}

class infoGrabbing extends HTMLElement {
	constructor() {
		super();

		this.dragItem = this;
		this.parentEle = this.dragItem.closest(".product[ulanka-product-layout]");
		this.innerContainer = this.dragItem.closest(".product__info-wrapper").querySelector("ele-grouping");
		this.slideAlert = this.dragItem.closest(".product__info-wrapper").querySelector('.slide-alert');
		this.productInfo = this.parentEle.querySelector(".product__info-wrapper");
		this.mediaProduct = this.parentEle.querySelector(".product__media-wrapper");
		this.active = false;

		this.currentY = 0;
		this.initialY = 0;
		this.yOffset = 0;
		this.ElementY = 0;
		this.touchMove = 0;


		this.dragItem.addEventListener(
			"touchstart",
			(event) => this.dragStart(event),
			false
		);
		this.dragItem.addEventListener(
			"touchend",
			(event) => this.dragEnd(event),
			false
		);
		this.innerContainer.addEventListener(
			"touchmove",
			(event) => this.dragMoveCenter(event),
			false
		);
		this.dragItem.addEventListener(
			"touchmove",
			(event) => this.dragMove(event),
			false
		);
	}

	openInfo() {
		this.productInfo.classList.add("is-active", "transition");
	}

	dragStart(event) {
		console.log(event)
		if (event.type === "touchstart") {
			this.initialY = event.touches[0].clientY;
			this.ElementY = event.touches[0].clientY;

			if (this.productInfo.classList.contains('animate__animated')) {
				this.productInfo.classList.remove('animate__animated', 'animate__bounce', 'animate__slow');
			}

			setTimeout(() => {
				if (this.innerContainer.classList.contains('origin-state')) {
					this.innerContainer.classList.remove('origin-state');
				}	
			}, 450);

			this.slideAlert ? this.slideAlert.classList.add('hidden') : '';
		} else {
			this.initialY = event.clientY;
			this.ElementY = event.clientY;
		}
		this.active = true;
	}

	dragEnd(event) {
		setTimeout(() => {
			this.initialY = this.currentY;
			this.active = false;

			console.log(event)

			if (this.currentY > 10) {
				this.productInfo.classList.remove("is-active");
				this.mediaProduct.classList.remove("is-remove");
				this.innerContainer.classList.remove('origin-state');
				this.slideAlert ? this.slideAlert.classList.remove('hidden') : '';
				setTimeout(() => {
					if (this.innerContainer.classList.contains('origin-state')) {
						this.innerContainer.classList.remove('origin-state');
					}
				}, 400);
				enableSlider();
			} else if (this.currentY < -10) {
				this.productInfo.classList.add("is-active");
				this.mediaProduct.classList.add("is-remove");

				if (this.innerContainer.classList.contains('origin-state')) {
					this.innerContainer.classList.remove('origin-state');
				}

				if (this.productInfo.classList.contains('animate__animated')) {
					this.productInfo.classList.remove('animate__animated', 'animate__bounce', 'animate__slow');
				}

				enableNotScrollSlider();
			} else {
				this.productInfo.classList.remove("is-active");
				this.mediaProduct.classList.remove("is-remove");

				setTimeout(() => {
					if (this.innerContainer.classList.contains('origin-state')) {
						this.innerContainer.classList.remove('origin-state');
					}
				}, 400);

				this.slideAlert ? this.slideAlert.classList.remove('hidden') : '';
				
				enableNotScrollSlider();
			}

			this.productInfo.style.transform = "";
			this.currentY = 0;
			this.setTranslate();

			this.productInfo.classList.add("transition");

			setTimeout(() => {
				this.productInfo.classList.remove("transition");
			}, 450);
		}, 1);
	} 

	dragMoveCenter(event) {
		if (event.type === "touchmove") {
			this.touchMove = event.touches[0].clientY
			this.productInfo.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });

			if (this.innerContainer.classList.contains('origin-state')) {
				if (this.touchMove > 550) {
					this.productInfo.classList.add("transition");
					this.productInfo.classList.remove("is-active");
					this.mediaProduct.classList.remove("is-remove");
					this.slideAlert ? this.slideAlert.classList.remove('hidden') : '';
					setTimeout(() => {
						enableSlider();
						this.productInfo.classList.remove("transition");
						setTimeout(() => {
							this.innerContainer.classList.remove('origin-state');
						}, 400);
					}, 450);
				}
			}
		} else {
			this.currentY = event.clientY - this.initialY;
		}
	}

	// New method to handle scroll
	handleScroll(e) {
		// Here you can safely log or use the scroll position
		if (e.target.scrollTop <= 0) {
			this.innerContainer.classList.add('origin-state');
		}else{
			this.innerContainer.classList.remove('origin-state');
		}
	}

	dragMove(event) {
		if (!this.active) {
			return;
		}
		// event.preventDefault(); // Here you prevent the default behavior of touchmove event
		if (event.type === "touchmove") {
			this.currentY = event.touches[0].clientY - this.initialY;
			enableNotScrollSlider();
		} else {
			this.currentY = event.clientY - this.initialY;
		}
		this.yOffset = this.currentY;
		this.setTranslate();
		if (!this.parentEle.classList.contains("append-active")) {
			appendChildas(this.parentEle);
			this.parentEle.classList.add("append-active");
		}

	}

	setTranslate() {
		if (this.productInfo.classList.contains("is-active")) {
			this.productInfo.style.transform = `translateY(${this.currentY}px)`;
		} else {
			this.productInfo.style.transform = `translateY(${this.currentY}px)`;
		}
	}
}

customElements.define("info-grabbing", infoGrabbing);

function appendChildas(element) {
	var Ele = element.querySelector("ele-grouping");
	var parentEles = Ele.closest(".product-packaged");
	var GroupingInner = document.createElement("div");
	GroupingInner.classList.add("ele-grouping-inner");
	var details = document.querySelectorAll("section.section-grouping:not(.append-section)");
	details.forEach((detail) => {
		detail.style.display = "none";
		var clonedDetail = detail.cloneNode(true);
		Ele.appendChild(clonedDetail);
		clonedDetail.classList.add("append-section");
	});
	var parentElem = parentEles.querySelector(".product__info-wrapper");
	var GroupingElement = parentElem.querySelector(".ele-grouping");
	if (GroupingElement) {
		GroupingElement.parentNode.insertBefore(Ele, GroupingElement.nextSibling);
	}
	var footerSection = document.querySelector(
		".shopify-section-group-footer-group"
	);
	if (footerSection) {
		Ele.appendChild(footerSection.cloneNode(true));
	}
	let productAccordions = parentEles.querySelectorAll(
		".product__accordion.accordion"
	);
	var AccordionWrapper = document.createElement("div");
	AccordionWrapper.classList.add("accordion-product");
	productAccordions.forEach((accordion) => {
		AccordionWrapper.appendChild(accordion.cloneNode(true));
		accordion.remove();
	});
	var GroupingElement = parentElem.querySelector(".ele-grouping-inner");
	if (Ele) {
		Ele.insertBefore(AccordionWrapper, GroupingElement.firstChild);
	} else {
		if (AccordionWrapper) {
			Ele.appendChild(AccordionWrapper);
		}
	}
}